import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { useAppSelector } from "store/hooks"
import { UITypes } from "types"
import TemperatureScale from "types/enums/TemperatureScale"

import { getRoundedTemperature } from "utils/getRoundedTemperature"
import parseCelsiusToFahrenheit from "utils/parseCelsiusToFahrenheit"
const Container = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: var(--text-primary);
`

interface PerformanceTestTempChangeProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const TempChangeOfPerformanceTest = ({ cell: { row } }: PerformanceTestTempChangeProps) => {
  const userTemperatureScale = useAppSelector(state => state.user.userTemperatureScale)
  const temperatureMark = userTemperatureScale === TemperatureScale.CELSIUS ? "C" : "F"

  const { start_temp, end_temp } = row.original.temp_change.value as { start_temp: number; end_temp: number }

  if (!start_temp || !end_temp) return null

  const parsedStartTemp =
    userTemperatureScale === TemperatureScale.CELSIUS ? start_temp : parseCelsiusToFahrenheit(start_temp)
  const parsedEndTemp =
    userTemperatureScale === TemperatureScale.CELSIUS ? end_temp : parseCelsiusToFahrenheit(end_temp)

  return (
    <Container>
      From {getRoundedTemperature(parsedStartTemp, 1, true)} {temperatureMark} to{" "}
      {getRoundedTemperature(parsedEndTemp, 1, true)} {temperatureMark}
    </Container>
  )
}
